// extracted by mini-css-extract-plugin
export default {"input":"TariffInput_input__UObHt"};